import { getInstanceId } from '@va/dashboard/selectors/app';
import { PageContent } from '@va/dashboard/shared/ui-layout';
import { useTranslate } from '@va/localization';
import { isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import { CopyActionCard } from '@va/ui/cards';
import { Paragraph } from '@va/ui/design-system';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TrackingManualCodeInstallation from './manual-installation/TrackingManualCodeInstallation';

const TrackingCodeDetails = () => {
  const highlightWebsiteId = window.location.hash === '#highlight-website-id';

  const translate = useTranslate();
  const websiteId = useSelector(getInstanceId);

  const trackingCodeLinks = useMemo(
    () => [
      {
        label: translate('trackingCode.instructions.avoidAdblockers'),
        href: translate('trackingCode.instructions.avoidAdblockersUrl'),
      },
      {
        label: translate('trackingCode.instructions.installSnippetGuide'),
        href: translate('trackingCode.instructions.installSnippetGuideUrl'),
      },
      {
        label: translate('trackingCode.instructions.contactOurSupport'),
        href: translate('trackingCode.instructions.contactOurSupportUrl'),
      },
      {
        label: translate('trackingCode.instructions.bookADemoOnline'),
        href: translate('trackingCode.instructions.bookADemoOnlineUrl'),
      },
    ],
    [translate],
  );

  return (
    <PageContent className='sm:p-18 grid grid-cols-3 sm:grid-cols-1 gap-x-16 sm:gap-0'>
      <div
        className={'mb-6px row-start-1 col-start-1 col-end-2 sm:col-span-1 sm:row-start-1 sm:row-end-2 sm:text-center'}
      >
        <Paragraph variant={'display'} variantSize={'small'}>
          {translate('trackingCode.instructions.description')}
        </Paragraph>
        <div className={'pt-4u'}>
          {trackingCodeLinks.map((t) => (
            <Paragraph key={t.href} variant={'body'} variantSize={'regular'} className={'pt-4u'}>
              <a href={t.href} target={'_blank'} className={'text-primary font-medium'} rel='noreferrer'>
                {t.label}
              </a>
            </Paragraph>
          ))}
        </div>
        <div className='pt-16u'>
          <CopyActionCard
            subTitle={websiteId}
            title={translate('trackingCode.instructions.websiteId')}
            className={classNames(highlightWebsiteId ? 'ring-2 ring-red-pure' : '')}
            showIcon={false}
          />
        </div>
      </div>

      <div className='h-full col-span-2 row-start-1 row-end-4 col-start-2 col-end-4 sm:col-span-1 sm:row-start-2 sm:row-end-3 pb-4 -mt-30'>
        <TrackingManualCodeInstallation allowCustomDomain={!isUserLoggedInWithCustomUrl()} />
        <a
          href={translate('trackingCode.installation.viewAllSupportedPlatformsUrl')}
          rel='noreferrer'
          target='_blank'
          className='w-full h-12 mt-3 bg-white-snow rounded-12 p-3 flex items-center justify-center hover:bg-white-smoke cursor-pointer text-center font-medium text-gray-charcoal'
        >
          {translate('trackingCode.installation.viewAllSupportedPlatforms')}
        </a>
      </div>
    </PageContent>
  );
};

export default TrackingCodeDetails;
